import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { CartProvider } from 'react-use-cart'

import './index.css'
import * as Sentry from '@sentry/browser'
import DevBanner from './components/Banner/DevBanner'

import App from './App'

const ENV = process.env.REACT_APP_ENVIRONMENT
const DSN = process.env.REACT_APP_SENTRY_DSN

if (ENV !== 'development') {
  console.log('Sentry')
  Sentry.init({ dsn: DSN })
}

// bootstrap-theme file for bootstrap 3 only

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <CartProvider>
        {ENV === 'development' && <DevBanner />}
        <App />
        {ENV === 'development' && <DevBanner />}
      </CartProvider>
    </BrowserRouter>
  </React.StrictMode>
)
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
